import {
  createCompanyContact,
  deleteCompanyContact,
  updateCompanyContact,
} from '@store/business/CompanyContactReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const CompanyContactForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.companyContact)
  const dispatch = useAppDispatch()

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          const finalData = {
            ...values,
            phone: formatPhoneNumberToE164FromPhoneInput(values.phone),
          }

          return dispatch(createCompanyContact(finalData)).then(() => {
            return true
          })
        },
        update: async (values) => {
          const finalData = {
            ...values,
            phone: formatPhoneNumberToE164FromPhoneInput(values.phone),
          }
          return dispatch(updateCompanyContact(finalData)).then(() => {
            return true
          })
        },
        delete: async (values) =>
          dispatch(deleteCompanyContact(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

CompanyContactForm.displayName = 'CompanyContactForm'

export default CompanyContactForm
